import {
  ILayoutSettings,
  mapLayoutSettingProperty,
} from 'core-components/sitebuilder/models/ILayoutSettings'

export const getLayoutProperties = (properties: ILayoutSettings['properties']) => {
  const newLayoutProperties = {}
  Object.keys(properties).forEach((el) => {
    const propertyData = mapLayoutSettingProperty(properties[el])
    if (propertyData?.defaultValue) {
      Object.assign(newLayoutProperties, { [el]: propertyData.defaultValue })
    }
  })
  return newLayoutProperties
}
